import { type FC } from 'react';
import { Layout } from 'features/Layouts/Layouts';
import { Box } from '@mantine/core';
import { EmployedsProfileContentDesktop } from './EmployedsProfileContentDesktop';
import { EmployedsProfileContentMobile } from './EmployedsProfileContentMobile';

export const EmployedsProfileContent: FC = () => {
  return (
    <Layout>
      <Box visibleFrom='sm'>
        <EmployedsProfileContentDesktop />
      </Box>
      <Box hiddenFrom='sm'>
        <EmployedsProfileContentMobile />
      </Box>
    </Layout>
  );
};
